import AgGridVueCustomTsx, {AgColControl, ColDefCustom} from "../agGridVueCustomTsx";
import LocalStore from "../../../util/LocalStore";

/**
 * @Author:
 * @Description: ag 列的缓存服务
 * @DateTime: Created in 10:47 2019-08-15
 */

export default class AgColService {
	ctx: AgGridVueCustomTsx

	constructor (ctx: AgGridVueCustomTsx) {
		this.ctx = ctx
	}

	/**
	 * 根据缓存的控制条件  生成新的列
	 */
	getColsByCacheControl (): ColDefCustom[] {
		// 过滤不需要控制的列 固定的列不在控制范围内
		let cols = this.ctx.columnDefs.filter((i) => !i.pinned)
		if (this.ctx.needColControl) {
			let colControlMap = (LocalStore.getPathData(this.ctx.cacheKey + '-colControl') || {}) as AgColControl
			let newCols: ColDefCustom[] = []
			for (let i = 0, l = cols.length; i < l; i++) {
				let item = cols[i];
				let field = item.field as string
				if (colControlMap.hasOwnProperty(field)) {
					item.hide = colControlMap[field].hide || false
				} else {
					// 新加的行 放在上一行所在 rank 后面
					let rank = 0
					if (i !== 0) {
						rank = colControlMap[cols[i - 1].field as string].rank + 1
					}
					for (let k in colControlMap) {
						colControlMap[k].rank >= rank && colControlMap[k].rank++
					}
					colControlMap[field] = {hide: item.hide || false, rank}
				}
			}
			// 根据最新的rank(因为可能有新加的列，也有可能有删除的列)
			for (let i = 0, l = cols.length; i < l; i++) {
				let item = cols[i];
				newCols[colControlMap[item.field as string].rank] = item
			}
			newCols = newCols.filter(Boolean)
			return newCols
		} else {
			return cols
		}
	}

	setColCacheByNewCols () {
		let newCols: ColDefCustom[] = this.ctx.colControl
		let newColControlMap: AgColControl = {}
		newCols.forEach((i, index) => {
			newColControlMap[i.field as string] = {rank: index, hide: i.hide || false}
		})
		// 设置新的缓存
		LocalStore.setPathData(newColControlMap, this.ctx.cacheKey + '-colControl')
	}

	colHideChange (i: ColDefCustom, flag: boolean) {
		i.hide = !flag
		this.ctx.colControl = [...this.ctx.colControl]
		this.setColCacheByNewCols()
	}

	/**
	 * 创建选择框的列
	 */
	static createSelectionCol (): ColDefCustom {
		return {
			headerName: '',
			field: 'selection',
			// pinned: 'left',
			checkboxSelection: true,
			headerCheckboxSelection: true,
			width: 50,
			maxWidth: 50,
			minWidth: 50
		}
	}

	static createSerialCol(serialNum: number) {
		return {
			headerName: '序号',
			field: 'index',
			maxWidth: 70,
			width: 70,
			minWidth: 70,
			// pinned: 'left',
			suppressSorting: true,
			cellStyle: {textAlign: 'center'},
			cellRenderer: (params) => {
                if(params.data.footer) {
                    return ''
                }
				return serialNum + params.rowIndex + 1
			}
		}
	}

}
